module.exports = __webpack_public_path__ + "static/media/icon-twitter.5492e1e8.svg";